import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // اضافه کردن useNavigate

interface Currency {
  id: number;
  name: string;
  icon_link: string;
}
const CurrencyList = () => {
  const [data, setData] = useState<Currency[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api-panel.parsianbit.com/publish/v1/currency"
        );

        const currencies = response.data?.data?.currencies || [];

        setData(currencies);
        setLoading(false);
      } catch (err: any) {
        console.error("Error fetching data:", err);
        setError("خطا در دریافت داده‌ها");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <CircularProgress
        sx={{
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 4,
        }}
      />
    );
  }
  if (error) return <p>{error}</p>;
  if (!Array.isArray(data) || data.length === 0)
    return <p>داده‌ای برای نمایش وجود ندارد.</p>;

  return (
    <>
      <Typography
        variant="h6"
        component="p"
        sx={{ color: "text.title", textAlign: "center", my: 2.5 }}
      >
        ارز های محبوب
      </Typography>
      <Grid container columns={15} spacing={2}>
        {data.map((currency) => (
          <Grid
            item
            xs={15}
            sm={7}
            md={5}
            lg={3}
            key={currency.id}
            sx={{ cursor: "pointer" }}
          >
            <Box
              sx={{
                bgcolor: "background.darkBlack",
                p: 1.25,
                borderRadius: "10px",
              }}
            >
              <Box>
                <img src={currency.icon_link} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="subtitle1"
                component="p"
                sx={{ color: "text.primary", textAlign: "center", mt: 1.5 }}
              >
                {currency.name}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default CurrencyList;
